import { useEffect } from 'react';
import { useSnapshot } from 'valtio';

import * as updatedProductStore from '@cartwhl/common/stores/updatedProductStore';
import * as userStore from '@cartwhl/common/stores/userStore';

import PurchaseCreditsModal from './PurchaseCreditsModal';

/** Mount once per app (e.g. next to other global modals) so `openPurchaseCreditsModal` can open the UI from anywhere. */
export default function PurchaseCreditsModalHost() {
  const snap = useSnapshot(updatedProductStore.purchaseCreditsModalState);
  const { organizationInfo } = useSnapshot(userStore.state);
  const inStripeFreeTrial = organizationInfo?.inStripeFreeTrialPeriod === true;

  useEffect(() => {
    if (inStripeFreeTrial) {
      updatedProductStore.closePurchaseCreditsModal();
    }
  }, [inStripeFreeTrial]);

  if (!snap.isOpen || inStripeFreeTrial) {
    return null;
  }
  return (
    <PurchaseCreditsModal
      close={updatedProductStore.closePurchaseCreditsModal}
      payload={{
        variant: snap.variant,
        creditsRemaining: snap.creditsRemaining,
      }}
    />
  );
}
